import React, { useEffect } from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Control, useWatch } from "react-hook-form";
import { getCurrencyAmountLabel } from "@/utils/currencyUtils";

type AmountFieldProps = {
  control: Control<any>;
};

const AmountField: React.FC<AmountFieldProps> = ({ control }) => {
  // Get the current value of original_currency field
  const currency = useWatch({
    control,
    name: "original_currency",
    defaultValue: "TRY"
  });

  return (
    <FormField
      control={control}
      name="amount"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm text-muted-foreground mb-1">{getCurrencyAmountLabel(currency)}</FormLabel>
          <FormControl>
            <Input
              type="number"
              inputMode="decimal"
              pattern="[0-9]*\.?[0-9]*"
              placeholder="0.00"
              {...field}
              className="bg-background"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default AmountField;
